import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const DangerIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG viewBox="0 0 20 18" {...props} fill="none">
      <path
        d="M10 6.49993V9.83326M10 13.1666H10.0083M8.575 2.21659L1.51667 13.9999C1.37114 14.2519 1.29414 14.5377 1.29333 14.8287C1.29251 15.1197 1.36791 15.4059 1.51202 15.6587C1.65614 15.9115 1.86394 16.1222 2.11476 16.2698C2.36558 16.4174 2.65067 16.4967 2.94167 16.4999H17.0583C17.3493 16.4967 17.6344 16.4174 17.8852 16.2698C18.1361 16.1222 18.3439 15.9115 18.488 15.6587C18.6321 15.4059 18.7075 15.1197 18.7067 14.8287C18.7059 14.5377 18.6289 14.2519 18.4833 13.9999L11.425 2.21659C11.2764 1.97168 11.0673 1.76919 10.8177 1.62866C10.5681 1.48813 10.2864 1.41431 10 1.41431C9.71356 1.41431 9.43194 1.48813 9.18234 1.62866C8.93273 1.76919 8.72356 1.97168 8.575 2.21659Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSVG>
  )
}
